import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class ResourceService {
	public static resourceGetByFilter(input: any) {
		return Http.axios()
			.post("/api/Product/GetAllProducts", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static resourceSave(input: any) {
		return input?.id > 0
			? (Http.axios()
					.put("/api/Product/update", input?.resourceInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					}) as AxiosPromise<any>)
			: (Http.axios()
					.post("/api/Product/add", input?.resourceInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					}) as AxiosPromise<any>);
	}

	public static resourceGetDetail(id: any) {
		return Http.axios()
			.get("/api/Product/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static resourceDelete(id: any) {
		return Http.axios()
			.delete("/api/Product/delete/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static resourceUpdateStatus(input: any) {
		return Http.axios()
			.post("/api/Product/update-product-status", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
